import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Chip } from './Chip';
import { HoursList } from './HoursList';
import type { PublicOrganization } from '../types';

// Opening hours, shown only when the business turned hours on.
export function HoursCard({ organization, elevated = false }: { organization: PublicOrganization; elevated?: boolean }) {
  const { t } = useTranslation('bookingPage');
  const hours = organization.booking_page.hours;
  if (!hours) return null;

  return (
    <section className={cn('flex flex-col gap-3.5 rounded-4xl border border-line bg-surface p-5 sm:p-[22px]', elevated && 'shadow-card')} data-testid="hours-card">
      <div className="flex items-center justify-between gap-3">
        <h3 className="inline-flex items-center gap-2 font-sans text-[15px] font-semibold text-ink">
          <Clock className="h-4 w-4 text-soft" />
          {t('hours.title')}
        </h3>
        {hours.open_now && <Chip tone="success">{t('hours.openNow')}</Chip>}
      </div>
      <HoursList hours={hours} timeZone={organization.timezone} />
    </section>
  );
}
